import { useContext } from "react";
import { Link } from "react-router-dom";
import { useTitle } from "react-use";
import { Box } from "../components/Box";
import { Container } from "../components/Container";
import { FlexContainer, FlexItem } from "../components/Flex";
import { MotionBox } from "../components/MotionBox";
import { SceneLink } from "../components/SceneLink";
import { Text } from "../components/Text";
import { ArtifactThemesContext } from "../context/ArtifactsContext";
import { useGetArtifacts } from "../hooks/useGetArtifacts";
import { useSetLogoStyle } from "../hooks/useSetLogoStyle";
import { LayoutScroll } from "../layout/LayoutScroll";

export const Sitemap: React.FC = ({}) => {
  useTitle("Sitemap | Boots Exhibition");
  const { artifactThemes } = useContext(ArtifactThemesContext);

  useGetArtifacts();

  useSetLogoStyle("dark");

  return (
    <LayoutScroll>
      <FlexItem
        pt={["96px", null, "120px", "160px"]}
        flex="1"
        backgroundColor="violet"
        pb={[4, null, null, 5]}
      >
        <Container maxWidth={3}>
          <Box mb={[3, null, null, 5]}>
            <Text variant="h1">Sitemap</Text>
          </Box>

          <Box mb={4}>
            <Link to="/">
              <MotionBox display="inline-block" whileHover={{ scale: 1.02 }}>
                <SceneLink label="Exhibit themes" variant="md" />
              </MotionBox>
            </Link>
          </Box>
          <FlexContainer
            margin={[-2, null, null, null, -3]}
            flexWrap="wrap"
            pb={4}
          >
            {artifactThemes.map((theme) => (
              <FlexItem
                key={theme.id}
                flex={["0 0 100%", null, "0 0 50%"]}
                padding={[2, null, null, null, 3]}
              >
                <Link to={`/themes/${theme.slug}`}>
                  <MotionBox
                    display="inline-block"
                    whileHover={{ scale: 1.02 }}
                  >
                    <SceneLink label={theme.name} iconColor="violetLight" />
                  </MotionBox>
                </Link>
              </FlexItem>
            ))}
          </FlexContainer>
          <Box my={4}>
            <Link to="">
              <MotionBox display="inline-block" whileHover={{ scale: 1.02 }}>
                <Text variant="h3" as="span">
                  About the exhibit
                </Text>
              </MotionBox>
            </Link>
          </Box>
          <Box my={4}>
            <Link to="">
              <MotionBox display="inline-block" whileHover={{ scale: 1.02 }}>
                <Text variant="h3" as="span">
                  Cinema room
                </Text>
              </MotionBox>
            </Link>
          </Box>
          <Box my={4}>
            <Link to="">
              <MotionBox display="inline-block" whileHover={{ scale: 1.02 }}>
                <Text variant="h3" as="span">
                  Pharmacy in time
                </Text>
              </MotionBox>
            </Link>
          </Box>
        </Container>
      </FlexItem>
    </LayoutScroll>
  );
};
